// extracted by mini-css-extract-plugin
export default {"root":"BurgerIcon_root__QOqAP","path":"BurgerIcon_path__YfSOP"};